export const useFileDownloader = () => (
  {
    download: (content: object, filename: string = 'download.json') => {
      const json = JSON.stringify(content, null, 2);
      const link = document.createElement('a');
      link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(json));
      link.setAttribute('download', filename);
      link.click();
      link.remove();
    }
  }
);